import { axios } from "utils";

import { ADMIN_CREDIT_FORECASTS_URL as endpoint } from "consts";

export const getAllCreditForecasts = async (data) => axios.get(`${endpoint}`, { data });

export const addCreditForecast = async (data) => axios.post(`${endpoint}`, { data });

export const updateCreditForecasts = async (data) => axios.put(`${endpoint}`, { data });

export const deleteCreditForecast = async (data) => axios.delete(`${endpoint}/${data.forecastId}`, { data });
